/** Реквизиты оператора ПДн. Источник: ЕГРИП / уведомление РКН № 77-26-566655. */

export const OPERATOR_NAME =
  'Индивидуальный предприниматель Власенко Борис Анатольевич';
export const OPERATOR_INN = '772100754584';
export const OPERATOR_OGRNIP = '317774600300552';
export const OPERATOR_OGRNIP_DATE = '23.06.2017';
export const OPERATOR_EMAIL = 'boris-vlasenko@yandex.ru';
export const OPERATOR_PHONE = '+7 (962) 405-97-24';
export const OPERATOR_REGION = 'г. Москва';
export const OFERTA_PATH = '/oferta';
export const CONTACT_VK = 'https://vk.com/boris_vlasenko';
export const POLICY_DATE = '22 сентября 2026 г.';
export const PROCESSING_START_DATE = '19 августа 2026 г.';
export const SITES_LABEL = 'new.diobuch.ru и diobuch.ru';

export const HOSTING_NAME = 'ООО «Мастерхост»';
export const HOSTING_INN = '7703797777';
export const HOSTING_OGRN = '1137746890027';
export const HOSTING_DC_ADDRESS =
  'г. Москва, 1-я Останкинская ул., д. 1, стр. 1';
export const HOSTING_LEGAL_ADDRESS =
  'г. Москва, 2-й Южнопортовый проезд, д. 20, корп. А, стр. 4';
